module.exports = __webpack_public_path__ + "static/img/p1.65459b85.png";